import { units } from '@ui/css';
import { colors } from '@ui/kit';
import { combineTokens, makeSelectors } from '@utils/css';

const tokens = combineTokens("--pie", {
  segmentWidth: units.px(25),
  gradient: `${colors.gray.sim10()} 0%, ${colors.gray.sim10()} 100%`,
  offset: 0,
  pointX: 0,
  pointY: 0
});
const wrapper = "_35swiwie5l";
const chart = "_35sc1cdw6oi";
const text = "_35st1fcndav";
const icon = "_35sihxhsau";
const separator = "_35ss4wbxoa";
function getPointOnCircle(t) {
  const deg = t * 360 - 90;
  const rad = deg * (Math.PI / 180);
  return {
    x: 0.5 + 0.5 * Math.cos(rad),
    y: 0.5 + 0.5 * Math.sin(rad)
  };
}
makeSelectors({
  wrapper,
  chart,
  text
});

export { chart, getPointOnCircle, icon, separator, text, tokens, wrapper };
import "./_pie-chart.style.linaria.module.css";
//# sourceMappingURL=_pie-chart.style.js.map
